import { FC } from "react";
import { Tag, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ListCard, ListCardField } from "../../../common/components/ListCard";
import { DateTime } from "../../../common/components/DateTime";
import {
    IhgBrief,
    IhgBriefStatus,
    IhgBriefType,
    IHG_BRIEF_TYPE_LABELS,
    IHG_STATUS_LABELS,
} from "../IhgDemoTypes";

const { Link } = Typography;

const RECOMMENDATION_COLOR: Record<string, string> = {
    Yes: "green",
    Conditional: "gold",
};

interface IhgBriefCardProps {
    brief: IhgBrief;
}

export const IhgBriefCard: FC<IhgBriefCardProps> = ({ brief }) => {
    const navigate = useNavigate();

    const fields: ListCardField[] = [
        {
            label: "Subject",
            span: 3,
            content: (
                <Link strong ellipsis>
                    {brief.subject}
                </Link>
            ),
        },
        {
            label: "Type",
            content:
                brief.briefType === IhgBriefType.CATEGORY_BENCHMARK ? (
                    <Tag color="blue">{IHG_BRIEF_TYPE_LABELS[brief.briefType]}</Tag>
                ) : (
                    <Tag>{IHG_BRIEF_TYPE_LABELS[brief.briefType]}</Tag>
                ),
        },
        {
            label: "Category",
            span: 2,
            content: brief.category,
        },
        {
            label: "Goal",
            span: 2,
            content: brief.goalLabel,
        },
        {
            label: "Status",
            content:
                brief.status === IhgBriefStatus.PROCESSING ? (
                    <Tag color="processing" icon={<LoadingOutlined />}>
                        {IHG_STATUS_LABELS[brief.status]}
                    </Tag>
                ) : (
                    <Tag color="success">{IHG_STATUS_LABELS[brief.status]}</Tag>
                ),
        },
        {
            label: "Recommendation",
            content: brief.recommendation ? (
                <Tag color={RECOMMENDATION_COLOR[brief.recommendation] || "default"}>
                    {brief.recommendation}
                </Tag>
            ) : (
                "—"
            ),
        },
        {
            label: "Created",
            content: <DateTime date={new Date(brief.createdAt)} showTime={false} />,
        },
    ];

    return (
        <ListCard
            onClick={() => navigate(`/superadmin/demo/ihg-brief/${brief.id}`)}
            logo={
                brief.logoUrl ? (
                    <img
                        src={brief.logoUrl}
                        alt={brief.subject}
                        // The shared ListCard styles logos for square avatars
                        // (object-fit: cover); wide logo marks need contain.
                        style={{
                            width: "100%",
                            height: "100%",
                            minWidth: 0,
                            objectFit: "contain",
                            padding: 10,
                            background: "#ffffff",
                        }}
                    />
                ) : undefined
            }
            logoFallback={brief.subject}
            fields={fields}
            columns={12}
            style={{ background: "#fafafa", borderBottom: "1px solid #d9d9d9" }}
        />
    );
};
